<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      }
    }
  }
</script>
<template>
  <h2 :class="$style.sectionTitle">{{ title }}</h2>
</template>
<style lang="scss" module>
  .sectionTitle {
    margin-bottom: 2.22rem;
    font-size: 2.5rem;
    letter-spacing: 0.15em;
    @include max-lg {
      font-size: 1.5rem;
    }
    @include max-md {
      font-size: 1.25rem;
      margin-bottom: 24px;
    }
  }
</style>
